import React from "react";
import { createUseStyles } from "react-jss";

export interface MelaButtonGroupProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  wrap?: boolean;
  orientation?: "horizontal" | "vertical";
  framed?: boolean;
  compact?: boolean;
  dataTestId?: string;
}

interface MelaButtonGroupStyleProps {
  wrap: boolean;
  orientation: "horizontal" | "vertical";
  framed: boolean;
  compact: boolean;
}

const useMelaButtonGroupStyles = createUseStyles({
  root: (props: MelaButtonGroupStyleProps) => ({
    display: "inline-flex",
    alignItems: "center",
    flexDirection: props.orientation === "vertical" ? "column" : "row",
    flexWrap: props.wrap ? "wrap" : "nowrap",
    gap: props.compact ? "0.25rem" : "0.375rem",
    width: props.orientation === "vertical" ? "100%" : "auto",
    padding: props.framed ? "0.25rem" : 0,
    borderRadius: props.framed ? 999 : 0,
    backgroundColor: props.framed ? "#ffffff" : "transparent",
    border: props.framed ? "1px solid #e2e8f0" : "none",
    boxShadow: props.framed ? "0 1px 2px rgba(15, 23, 42, 0.06)" : "none",
  }),
});

export const MelaButtonGroup = ({
  children,
  className = "",
  style,
  wrap = false,
  orientation = "horizontal",
  framed = true,
  compact = false,
  dataTestId,
}: MelaButtonGroupProps) => {
  const classes = useMelaButtonGroupStyles({
    wrap,
    orientation,
    framed,
    compact,
  });

  return (
    <div
      className={`${classes.root} ${className}`.trim()}
      style={style}
      data-testid={dataTestId}
      data-mela-button-group="true"
    >
      {children}
    </div>
  );
};
